<nav class="top-nav">
  <div class="nav-content">
    <div class="nav-left">
      <a routerLink="/overview" class="nav-logo" [attr.aria-label]="'admin.nav.brand' | adminTranslate">
        <img src="assets/logo.svg" alt="Freyr" class="nav-logo-img" />
        <span class="nav-logo-text">{{ 'admin.nav.brand' | adminTranslate }}</span>
      </a>

      <nav class="nav-sections" [attr.aria-label]="'admin.nav.sectionsAria' | adminTranslate">
        @for (item of navItems; track item.path) {
          <a
            [routerLink]="item.path"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: item.path === '/overview' }"
            class="nav-link">
            {{ item.labelKey | adminTranslate }}
          </a>
        }
      </nav>
      @if (monitoringMode) {
        <span class="nav-monitoring-badge">{{ 'admin.nav.monitoringMode' | adminTranslate }}</span>
      }
    </div>

    <div class="nav-right">
      <div class="nav-lang-wrap" #langWrap>
        <button
          type="button"
          class="nav-lang-trigger"
          (click)="toggleLangDropdown()"
          [attr.aria-expanded]="langDropdownOpen"
          [attr.aria-haspopup]="'true'"
          [attr.title]="(i18n.currentLang === 'fr' ? 'admin.nav.languages.fr' : 'admin.nav.languages.en') | adminTranslate">
          <img [src]="currentLangFlagSrc" alt="" class="nav-lang-flag" width="24" height="16" />
          <ui-inline-svg icon="chevron-down" iconClass="nav-dropdown-chevron"></ui-inline-svg>
        </button>
        @if (langDropdownOpen) {
          <div class="nav-dropdown">
            @for (lang of i18n.languages; track lang.code) {
              <button type="button" class="nav-dropdown-item nav-dropdown-item--lang" (click)="selectLang(lang.code)">
                <img [src]="lang.flagSrc" alt="" class="nav-lang-item-flag" width="22" height="15" />
                <span>{{ lang.labelKey | adminTranslate }}</span>
              </button>
            }
          </div>
        }
      </div>

      <button
        type="button"
        class="nav-btn-theme"
        (click)="themeService.toggle()"
        [attr.aria-label]="(themeService.currentTheme === 'dark' ? 'admin.nav.themeLight' : 'admin.nav.themeDark') | adminTranslate"
        [attr.title]="(themeService.currentTheme === 'dark' ? 'admin.nav.themeLightTitle' : 'admin.nav.themeDarkTitle') | adminTranslate">
        @if (themeService.currentTheme === 'dark') {
          <ui-inline-svg icon="theme-sun" iconClass="theme-toggle-icon"></ui-inline-svg>
        } @else {
          <ui-inline-svg icon="theme-moon" iconClass="theme-toggle-icon"></ui-inline-svg>
        }
      </button>

      @if (user; as currentUser) {
        <div class="nav-user-wrap" #userWrap>
          <button type="button" class="nav-user-trigger" (click)="toggleUserDropdown()" [attr.aria-expanded]="userDropdownOpen" [attr.aria-haspopup]="'true'" [attr.title]="currentUser.username">
            @if (currentUser.profileImageUrl) {
              <img [src]="currentUser.profileImageUrl" alt="" class="nav-user-avatar" width="32" height="32" />
            } @else {
              <span class="nav-user-initial">{{ currentUser.username.charAt(0) | uppercase }}</span>
            }
            <span class="nav-user-name">{{ currentUser.username }}</span>
            <ui-inline-svg icon="chevron-down" iconClass="nav-dropdown-chevron"></ui-inline-svg>
          </button>
          @if (userDropdownOpen) {
            <div class="nav-dropdown nav-dropdown--user">
              <button type="button" class="nav-dropdown-item" (click)="goToMainSite()">{{ 'admin.nav.goToMainSite' | adminTranslate }}</button>
              <button type="button" class="nav-dropdown-item" (click)="logout(); closeUserDropdown()">{{ 'admin.nav.logout' | adminTranslate }}</button>
            </div>
          }
        </div>
      }
    </div>
  </div>
</nav>
